module.exports = __webpack_public_path__ + "static/img/cat.fcef2941.webp";